module.exports = __webpack_public_path__ + "static/img/mega_dental.94c8b86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mega_dental.png
// module id = AJwG
// module chunks = 2